/**
 * @ignore
 * Created by !daletan on 2/30/93.
 */

'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import get from 'lodash.get';
import classNames from 'classnames';
import enabler from '../../../global/utils/enabler.es';
import contactDealerCopy from '../../constants/contactDealerCopy.json';
import HoldRequestInput from './HoldRequestInput';
import CallDealerButton from './CallDealerButton';
import { FormattedMessage, defineMessages, injectIntl, intlShape } from 'react-intl';

const placeholderMessages = defineMessages({
    placeholderTextV1: {
        id: 'pdp.ContactDealerMessage.placeholderTextV1',
        defaultMessage: 'Let us know how we can help you.',
    },
    placeholderTextV2: {
        id: 'pdp.ContactDealerMessage.placeholderTextV2',
        defaultMessage: 'Send a message to this seller to request more details or discuss price.',
    },
});

class ContactDealerMessage extends React.Component {
    constructor() {
        super();
        this.state = { name: '' };
        this.onNameInput = this.onNameInput.bind(this);
    }

    onNameInput(e) {
        this.setState({ name: e.target.value });
    }

    render() {
        const { name } = this.state;
        const {
            isLoggedIn,
            onNameEntered,
            onMessageFocused,
            onMessageInput,
            nameError,
            onMessageEntered,
            messageError,
            phoneError,
            isDealerMessageSending,
            onContactDealer,
            showRequestHold,
            isHoldRequestChecked,
            onHoldRequestClick,
            isRemoveContactDealerCTATestRunning,
            userId,
            hasUserId,
            item,
            itemId,
            viewer,
            dealerPk,
            page,
            intl,
        } = this.props;

        let buttonText = isRemoveContactDealerCTATestRunning ? 'Send Message' : 'Send';

        const rowCount = isRemoveContactDealerCTATestRunning ? 8 : 5;

        const messageLink = (
            <a href="https://support.1stdibs.com/s/article/Exchanging-Personal-Information">
                <FormattedMessage
                    id="pdp.ContactDealerMessage.sharingContactsPolicyLink"
                    defaultMessage="our policy"
                />
            </a>
        );

        let content = null;
        if (isRemoveContactDealerCTATestRunning) {
            content = (
                <p className="pdp-dealer-trade-test-info">
                    <span className="pdp-dealer-trade-test-title pdp-dealer-trade-test-contact-title">
                        <FormattedMessage
                            id="pdp.ContactDealerMessage.title"
                            defaultMessage="Send Us a Message"
                        />
                    </span>
                </p>
            );
        } else {
            content = (
                <div>
                    {!isLoggedIn && (
                        <div className="pdp-contact-name-wrapper">
                            <input
                                className="pdp-contact-name com-form-input"
                                onBlur={onNameEntered}
                                onFocus={onMessageFocused}
                                onChange={this.onNameInput}
                                value={name}
                            />
                            <span className="input-placeholder">Name</span>
                            {nameError && (
                                <p className="pdp-contact-errors">
                                    {contactDealerCopy.errors.isRequired}
                                </p>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        const callEnabled = enabler.isEnabled('call_dealer_button');
        const trackedPhoneNumber = get(item, 'seller.trackedPhone.phoneNumber');
        const callCtaContainerClass = classNames('call-seller-cta-wrapper', {
            ['is-hidden']: !(callEnabled && trackedPhoneNumber),
        });

        return (
            <div className="pdp-dealer-section pdp-contact-dealer">
                {content}
                <div className="dealer-message">
                    <textarea
                        name="dealerMessage"
                        className="pdp-contact-text"
                        onBlur={onMessageEntered}
                        onFocus={onMessageFocused}
                        placeholder={intl.formatMessage(
                            isRemoveContactDealerCTATestRunning
                                ? placeholderMessages.placeholderTextV1
                                : placeholderMessages.placeholderTextV2
                        )}
                        onChange={onMessageInput}
                        rows={rowCount}
                    />
                    {showRequestHold && (
                        <div className="hold-request-input">
                            <HoldRequestInput
                                isHoldRequestChecked={isHoldRequestChecked}
                                onClick={onHoldRequestClick}
                            />
                        </div>
                    )}
                    <button
                        className={`${
                            showRequestHold ? 'show-request-hold' : ''
                        } button-large button-primary pdp-contact-button`}
                        disabled={isDealerMessageSending}
                        onClick={onContactDealer}
                    >
                        {buttonText}
                    </button>
                </div>
                <div>
                    {messageError && (
                        <p className="pdp-contact-errors">{contactDealerCopy.errors.isRequired}</p>
                    )}
                    {phoneError && (
                        <p className="pdp-contact-errors">
                            {trackedPhoneNumber
                                ? `${contactDealerCopy.errors.dealerPhone} ${trackedPhoneNumber}.`
                                : contactDealerCopy.errors.supportPhone}
                        </p>
                    )}
                </div>
                <div className="pdp-buyer-policy">
                    <FormattedMessage
                        id="pdp.ContactDealerMessage.sharingContactsPolicy"
                        defaultMessage="Sharing contact information to purchase outside of 1stdibs is against {messageLink}."
                        values={{ messageLink }}
                    />
                </div>
                <div className={callCtaContainerClass}>
                    <div className="call-seller-copy">
                        <FormattedMessage
                            id="pdp.ContactDealerMessage.callSellerCopy"
                            defaultMessage="You may also contact the seller by phone"
                        />
                    </div>
                    <CallDealerButton
                        userId={userId}
                        hasUserId={hasUserId}
                        item={item}
                        itemId={itemId}
                        viewer={viewer}
                        dealerPk={dealerPk}
                        page={page}
                    />
                </div>
            </div>
        );
    }
}

ContactDealerMessage.defaultProps = {
    onMessageInput() {},
    phoneError: false,
};

ContactDealerMessage.propTypes = {
    isDealerMessageSending: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    hasErrors: PropTypes.bool,
    messageError: PropTypes.bool,
    nameError: PropTypes.bool,
    phoneError: PropTypes.bool,
    onContactDealer: PropTypes.func.isRequired,
    onMessageEntered: PropTypes.func.isRequired,
    onMessageFocused: PropTypes.func.isRequired,
    onMessageInput: PropTypes.func,
    onNameEntered: PropTypes.func.isRequired,
    price: PropTypes.number,
    showRequestHold: PropTypes.bool,
    isHoldRequestChecked: PropTypes.bool,
    onHoldRequestClick: PropTypes.func,
    isRemoveContactDealerCTATestRunning: PropTypes.bool,
    userId: PropTypes.string,
    hasUserId: PropTypes.bool,
    dealerPk: PropTypes.string,
    page: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object,
    itemId: PropTypes.string,
    intl: intlShape.isRequired,
};

export { ContactDealerMessage as Component };

export default Relay.createContainer(injectIntl(ContactDealerMessage), {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null,
    },
    fragments: {
        viewer: ({ hasUserId, userId, itemId }) => Relay.QL`
            fragment on Viewer {
                ${CallDealerButton.getFragment('viewer', { hasUserId, userId, itemId })}
            }
        `,
        item: ({ hasUserId, userId, itemId }) => Relay.QL`
            fragment on Item {
                seller {
                    trackedPhone {
                        phoneNumber
                    }
                }
                ${CallDealerButton.getFragment('item', { hasUserId, userId, itemId })}
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerMessage.jsx